/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-declarations */

export const openHelpWidget = () => {
  if (hubspot.zorse) {
    hubspot.zorse.openHelpWidget();
  } else if (hubspot.messages) {
    hubspot.messages.EXPERIMENTAL_API.requestWidgetOpen();
  }
};